module.exports = __webpack_public_path__ + "img/Mask Group 2937@2x.d9d737d5.png";